import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { error } from 'console';
import { DeleteConfirmModalComponent } from 'src/app/commons/delete-confirm-modal/delete-confirm-modal.component';
import { FilterService } from 'src/app/services/filter.service';
import { StaffService } from 'src/app/services/staff/staff.service';
import { UserDocumentService } from 'src/app/services/user-document.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'rail-ppe-list',
  templateUrl: './rail-ppe-list.component.html',
  styleUrls: ['./rail-ppe-list.component.scss']
})
export class RailPpeListComponent implements OnInit {
  @Input('staffList') staffList
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  pageSizeOptions: number[] = [25, 50, 100];
  // displayedPPEKitColumns: string[] = ['name', 'insuranceno', 'submissiondate', 'status', 'actions'];
  displayedPPEKitColumns: string[] = ['name', 'submissiondate', 'submittedBy', 'status', 'actions'];
  pendingPPEKitList = []
  approvePPEKitList = []
  noPendingDataMsg = {
    title: "No PPE Kits!",
    data: "No PPE request is submitted"
  }
  noPendingDataMsg2 = {
    title: "No Approved PPE Kits!",
    data: "No PPE request is approved"
  }
  _isDisplay = false
  _isCreate = false
  filterActive: Boolean = false;
  afterFilter: any;
  searchText
  activeTab: string = 'pending';
  singlePPEKitDetails
  loading = false
  isSpinnerId
  isSpinner: boolean = false
  user = JSON.parse(localStorage.getItem('userRoles'))
  operativeList = []
  isStaffViewPage: boolean = true;
  dynamicAddBtn

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: false }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _userDocumentService: UserDocumentService,
    public _utilityService: UtilityService,
    public _staffService: StaffService,
    public _route: Router,
    private _activatedRoute: ActivatedRoute,
    public _filter: FilterService,
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    if (this.user && this.user.isAdmin && this._route.url.includes('staff/view')) {
      this.isStaffViewPage = false;
      this._activatedRoute.params.subscribe(params => {
        let instructorId = params.id;
        this.getPPEKitList(instructorId)
      });
      // this.getPPEKitList()
    } else {
      console.log("CURRENT STATUS", this.isStaffViewPage)
      this.makeDynamicColumns()
      this.getPPEKitList()
    }
    if (this.user.isAdmin) this.dynamicAddBtn = 'Add New PPE Kit'
    else this.dynamicAddBtn = 'Request PPE'

    this.getStaff()
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.staffList && changes.staffList.currentValue) this.operativeList = changes.staffList.currentValue
  }



  // UTILITY

  updateData(instructors) {
    console.log("UPDATING DATA = ", instructors)
    this.dataSource = new MatTableDataSource(instructors);
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("ITEM", item)
      switch (property) {
        case 'submittedBy': return item.submittedBy.name;
        case 'name': return item.details.ppeName;
        case 'submissiondate': return item.createdAt
        case 'approvedDate': return item.approvedBy.approvedTime
        case 'approvedBy': return item && item.approvedBy ? item.approvedBy.name : ''
        case 'status': return item.status
        default:
          break;
      }
    }
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    // this.paginator._changePageSize(instructors.length)
  }


  setActiveTab(tab) {
    this.activeTab = tab
    if (tab === 'approve') {
      if (this.user && this.user.isAdmin) this.displayedPPEKitColumns = ['name', 'submissiondate', 'submittedBy', 'approvedDate', 'approvedTime', 'approvedBy', 'status', 'actions']
      else this.displayedPPEKitColumns = ['submissiondate', 'submittedBy', 'status', 'actions']
      // this.displayedPPEKitColumns = ['name', 'submissiondate', 'submittedBy', 'approvedBy', 'status', 'actions']
      this.updateData(this.approvePPEKitList)
    } else {
      if (this.user && this.user.isAdmin) this.displayedPPEKitColumns = ['name', 'submissiondate', 'submittedBy', 'status', 'actions']
      else this.displayedPPEKitColumns = ['submissiondate', 'submittedBy', 'status', 'actions']
      this.updateData(this.pendingPPEKitList)
    }
  }

  viewRailPPERequest(data) {
    console.log("DATA OF PPE", data)
    this.singlePPEKitDetails = data
    this._isDisplay = true
  }


  closeForm(event) {
    console.log("EVENT", event)
    this.singlePPEKitDetails = null
    this._isDisplay = false
    if (event && event.type === '_isCreate') {
      this.ngOnInit()
    }
  }




  addPPEKit() {
    this._isDisplay = true
    this._isCreate = true
  }


  makeDynamicColumns() {
    if (this.user && this.user.isOperative) {
      this.displayedPPEKitColumns = ['submissiondate', 'submittedBy', 'status', 'actions']
    }
  }

  filter(searchText) {
    this.afterFilter = null
    this.filterActive = true;

    if (searchText === '') {
      if (this.activeTab === 'pending') this.updateData(this.pendingPPEKitList);
      else this.updateData(this.approvePPEKitList)
      this.filterActive = false;
    }

    let pendingList

    if (this.activeTab === 'pending') pendingList = this.pendingPPEKitList
    else pendingList = this.approvePPEKitList

    let filteredIns = this._filter.staffFilterService(searchText, pendingList, ['ppeName']);
    console.log("FILTER RES", filteredIns)
    this.updateData(filteredIns)
    if (filteredIns.length <= 0) {
      this.afterFilter = {
        title: "No Pending Users!",
        data: "Sorry, no member matched your search"
      }
    }
  }
  // API CALL


  getPPEKitList(instructorId?) {
    this._userDocumentService.getPPEKitList(instructorId).subscribe((res) => {
      console.log("RESPONSE OF PPE KITS", res)
      this.pendingPPEKitList = res.submittedKits
      this.approvePPEKitList = res.approvedKits
      this.updateData(this.pendingPPEKitList)
      this.loading = false
    }, error => {
      console.log("ERROR WHILE GET", error)
    })
  }


  approvePPEKit(element) {
    console.log("when user is approved", element);
    let obj = {}
    if (element && element.instructorId) {
      obj['isPPEKit'] = true
      obj['content'] = 'approve'
      obj['isOperativeUser'] = false
    } else {
      obj['isPPEKit'] = true
      obj['content'] = 'approve'
      obj['isOperativeUser'] = true
    }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, obj).afterClosed().subscribe((res) => {
      console.log("RESPONSE OF ARCHIVE STAFF", res)
      if (res === undefined) return
      if (res === 'yes') {
        this.loading = true;
        this._userDocumentService.approvePPEKitRequest(element._id).subscribe((instructors) => {
          console.log("===instructorsinstructorsinstructorsinstructors===", instructors)
          this.getPPEKitList()
          // this.loading = false;
          this._utilityService.openSnackBar('PPE Kit Approved Successfully', 'Ok')
        }, (error) => {
          console.log("approve users some error occure ", error)
          this.loading = false
        });
      }
    })
  }

  rejectPPEKit(instructor) {
    let obj = {}

    if (instructor && instructor.instructorId) {
      obj['_isPPEKitReject'] = true
      obj['content'] = 'reject'
      obj['isOperativeUser'] = false
    } else {
      obj['_isPPEKitReject'] = true
      obj['content'] = 'reject'
      obj['isOperativeUser'] = true
    }
    this._utilityService.commonDialogBoxOpen(DeleteConfirmModalComponent, obj).afterClosed().subscribe((res) => {
      if (res === undefined) return
      if (res === 'yes') {
        this.loading = true
        this._userDocumentService.rejectPPEKitRequest(instructor._id).subscribe((instructors) => {
          console.log("===instructorsinstructorsinstructorsinstructors===", instructors.data)
          this.getPPEKitList()
          this.loading = false;
          this._utilityService.openSnackBar('PPE Kit Rejected Successfully', 'Ok')
        }, (error) => {
          console.log("approve users some error occure ", error)
          this.loading = false
        });
      }
    })
  }

  downloadPPEKit() {
    console.log("PPE KIT DOWNLOAD")
    this.loading = true
    this._userDocumentService.downloadPPEKitSpreadSheet().subscribe((res) => {
      console.log("SHEET DOWNLOAD DONE", res.msg)
      if (res) {
        const downloadLink = document.createElement("a");
        downloadLink.href = res.data;
        downloadLink.click();
        this._utilityService.handleSnackBar({ msg: res.msg, button: "Ok" })
      }
      this.loading = false
    }, error => {
      console.error("ERRROR", error)
      this._utilityService.handleSnackBar({ msg: error.msg, button: "Ok" })
      this.loading = false
    })
  }

  downloadPPEKitPdf(data) {

    this.isSpinnerId = data._id;
    this.isSpinner = true
    this._userDocumentService.downloadPPEKitPdf(data._id).subscribe((res) => {
      console.log("RES OF", res)
      console.log("DATA OF PACK", data)
      const downloadLink = document.createElement("a");
      downloadLink.href = data.pdfUrl;
      downloadLink.click();
      this._utilityService.handleSnackBar({ msg: "File downloaded successfully!", button: "Ok" })
      this.isSpinner = false;
      this.isSpinnerId = null
    }, err => {
      console.log("ERROR", err)
      this.isSpinner = false
      this.isSpinnerId = null
    })
  }

  getStaff() {
    this._staffService.getAllStaff().subscribe((res) => {
      console.log("===instructorsinstructorsinstructorsinstructors===", res.data.instructors)
      let newStaffArray = res.data.instructors.filter((a) => {
        if (a.isDelete == false && (!a.isArchive || a.isArchive == false)) {
          return a
        }
      })
      this.operativeList = newStaffArray;
      // this.staffCopy = newStaffArray
      // this.loading = false;
      // this.updateData(newStaffArray)
    });
  }

}
